const LocationIcon = ({ width = 14, height = 16, color = '#0086FF' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 8C7.48125 8 7.89323 7.84333 8.23594 7.53C8.57865 7.21667 8.75 6.84 8.75 6.4C8.75 5.96 8.57865 5.58333 8.23594 5.27C7.89323 4.95667 7.48125 4.8 7 4.8C6.51875 4.8 6.10677 4.95667 5.76406 5.27C5.42135 5.58333 5.25 5.96 5.25 6.4C5.25 6.84 5.42135 7.21667 5.76406 7.53C6.10677 7.84333 6.51875 8 7 8ZM7 16C4.65208 14.1733 2.89844 12.4767 1.73906 10.91C0.579687 9.34333 0 7.89333 0 6.56C0 4.56 0.703646 2.96667 2.11094 1.78C3.51823 0.593333 5.14792 0 7 0C8.85208 0 10.4818 0.593333 11.8891 1.78C13.2964 2.96667 14 4.56 14 6.56C14 7.89333 13.4203 9.34333 12.2609 10.91C11.1016 12.4767 9.34792 14.1733 7 16Z"
      fill={color}
    />
  </svg>
);

export default LocationIcon;
